import React from 'react';
import { Quote, Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  city: string;
  quote: string;
}
export function TestimonialCard({
  name,
  age,
  city,
  quote
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-2xl shadow-lg border-l-4 border-amber-400 flex flex-col h-full" data-id="element-359">
      <div className="flex gap-1 text-amber-400 mb-4" data-id="element-360">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-361" />)}
      </div>
      <div className="relative flex-grow" data-id="element-362">
        <Quote className="absolute -top-2 -left-2 w-8 h-8 text-blue-100 transform -scale-x-100" data-id="element-363" />
        <p className="text-gray-700 italic relative z-10 pl-4 mb-6 text-lg" data-id="element-364">
          "{quote}"
        </p>
      </div>
      <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-365">
        <p className="font-bold text-blue-900" data-id="element-366">
          {name}, {age} años
        </p>
        <p className="text-sm text-gray-500" data-id="element-367">{city}</p>
      </div>
    </div>;
}